import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    CircularProgress,
    Fade,
    Button,
    Modal,
    TextField
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
import Selectclass from '../Subjects/Components/selectclass';

const Dailywork = () => {

    const [currentClass, setCurrentClass] = useState('');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const [form, setForm] = useState({
        subject: '',
        description: ''
    });

    const CurrentClass = (getparam) => {
        setCurrentClass(getparam);
    };

    const fetchDailyWork = () => {
        if (!currentClass) return;

        setLoading(true);

        axios
            .get(`/api/dailywork?class_id=${currentClass}`)
            .then((res) => {
                setData(res.data.data);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchDailyWork();
    }, [currentClass]);

    const handleCreate = () => {
        if (!form.subject) return;

        axios.post("/api/dailywork", {
            WebSrn: 1, // change if needed
            class_id: currentClass,
            subject: form.subject,
            description: form.description,
            created_by: 1
        }).then(() => {
            setOpen(false);
            setForm({ subject: '', description: '' });
            fetchDailyWork();
        });
    };

    return (
        <Box sx={{ p: 4, background: '#f4f6f8', minHeight: '100vh' }}>

            <Selectclass Current={CurrentClass} />

            {/* Add Button */}
            {currentClass && (
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => setOpen(true)}
                    sx={{
                        mt: 3,
                        borderRadius: 3,
                        textTransform: 'none'
                    }}
                >
                    Create Task
                </Button>
            )}

            {/* Loading */}
            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            )}

            {/* Cards */}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: 3,
                    mt: 4
                }}
            >
                {data.map((item) => (
                    <Fade in timeout={400} key={item.srn}>
                        <Card
                            sx={{
                                borderRadius: 3,
                                transition: '0.3s',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    boxShadow: 6
                                }
                            }}
                        >
                            <CardContent>
                                <Typography variant="h6" fontWeight="bold">
                                    {item.subject}
                                </Typography>

                                <Typography variant="body2" sx={{ mt: 1 }}>
                                    {item.description}
                                </Typography>

                                <Typography
                                    variant="caption"
                                    sx={{ display: 'block', mt: 2 }}
                                >
                                    {new Date(item.date).toLocaleDateString()}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Fade>
                ))}
            </Box>

            {/* Modal */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: 3,
                        p: 4,
                        boxShadow: 24
                    }}
                >
                    <Typography variant="h6" mb={2}>
                        Create Daily Task
                    </Typography>

                    <TextField
                        fullWidth
                        label="Subject"
                        value={form.subject}
                        onChange={(e) =>
                            setForm({ ...form, subject: e.target.value })
                        }
                        sx={{ mb: 2 }}
                    />

                    <TextField
                        fullWidth
                        label="Description"
                        multiline
                        rows={3}
                        value={form.description}
                        onChange={(e) =>
                            setForm({ ...form, description: e.target.value })
                        }
                        sx={{ mb: 3 }}
                    />

                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleCreate}
                        sx={{ borderRadius: 3 }}
                    >
                        Save Task
                    </Button>
                </Box>
            </Modal>

        </Box>
    );
};

export default Dailywork;
